var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgArrowRightBlkRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 415.75 415.75",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,311.81 H 311.81 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 415.75)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(246.82 156.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-77.214 77.213c-0.577 0.578-1.516 0.578-2.094 0l-8.381-8.382c-0.579-0.578-0.579-1.514 0-2.095l57.85-57.848c0.931-0.93 0.274-2.527-1.049-2.527h-149.89c-0.821 0-1.482-0.664-1.482-1.482v-11.851c0-0.817 0.661-1.481 1.482-1.481h149.89c1.323 0 1.98-1.597 1.049-2.53l-57.85-57.848c-0.579-0.578-0.579-1.518 0-2.095l8.381-8.382c0.578-0.578 1.517-0.578 2.094 0l77.214 77.213c0.577 0.581 0.577 1.517 0 2.095"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlkRgb);
export default __webpack_public_path__ + "static/media/Arrow_Right_BLK_RGB.24c2b9a64ced3c8f43d46a198986e9f4.svg";
export { ForwardRef as ReactComponent };